import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M2 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })